module.exports = __webpack_public_path__ + "media/images/signatureOFF-7488b0cda69040a7c621334a22a40fe7.jpg";